import React, { useEffect, useState } from "react";
import SweetAlertModal from "../../components/SweetAlertModal/SweetAlertModal.js";
import Cancel from "./../../../assets/icons/close.png";
import itemImg from "./../../../assets/icons/menu.png";
import CustomDataGrid from "../../../components/CustomDataGrid/CustomDataGrid.tsx";
import { ToastContainer, toast } from "react-toastify";
import Typography from "@mui/material/Typography";
import AutoCompleteMultiSelect from "../../../pages/components/AutoCompleteMultiselect/AutoCompleteMultiSelect.tsx";

import axios from "axios";

import {
  Button,
  Grid,
  Switch,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";

import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";

import jwt_decode from "jwt-decode";

function FoodItemLinkDialog(props) {
  console.log(props);

  const [openDialog, setOpenDialog] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [openMenuCloseConfirmaitonModal, setopenMenuCloseConfirmaitonModal] =
    useState(false);
  const [openArchiveConfirmaitonModal, setopenArchiveConfirmaitonModal] =
    useState(false);
  const [selectedValue, setSelectedValue] = useState([]);
  const [dataRows, setDataRows] = useState([]);

  const [selectedDataRows, setSelectedDatarows] = React.useState([]);

  const getselectedData = (props) => {
    console.log(props);
    setSelectedDatarows(props);
  };

  const handleClose = () => {
    setopenMenuCloseConfirmaitonModal(false);
    if(Openfrom == "Main"){
      props.linkmodalclose()
    }
    else if(Openfrom == "Edit"){
      props.linkmodalclose2()
    };
    setRestaurantAdded([]);
    setMenuId([]);
    setSelectedValue([]);
    setfoodItemSelected([]);
  };
  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedRowId(null);
  };

  const {
    open,
    onClose,
    dialogType,
    id,
    cancledRes,
    onToggleSwitch,
    addNewSec,
    selectedRestaurants,
    Openfrom,
    openDialog: toggle,
  } = props;

  console.log(cancledRes);
  console.log(addNewSec);
  const apiAddress = process.env.REACT_APP_SECRET;

  const [restaurantId, setRestaurantId] = useState([]);

  const [foodItemSelected, setfoodItemSelected] = useState([]);
  const [copySectionId, setcopySectionId] = useState([]);

  const foodItemAddedvalue = (props) => {
    console.log(props);
    setfoodItemSelected(props);
    console.log(FoodItemdata);
  };

  useEffect(() => {
    loadRestaurantName();
  }, []);

  const Restauranttoken = JSON.parse(localStorage.getItem("parentrestaurant"));
  const RestauranttokenLocal = JSON.parse(localStorage.getItem("restaurant"));
  const [restaurantDatas, setRestaurantDatas] = React.useState([]);
  const token = localStorage.getItem("gotasteadmintoken");
  const [userId, setUserId] = useState();

  const [restaurantAdded, setRestaurantAdded] = useState([
    { id: RestauranttokenLocal.id, title: RestauranttokenLocal.name },
  ]);

  useEffect(() => {
    loadMenuData(restaurantAdded);
  }, [restaurantAdded]);

  const loadRestaurantName = () => {
    var decodedData = {};
    if (token != null) {
      try {
        decodedData = jwt_decode(token);

        setUserId(decodedData.UserId);

        // setTokenData(decodedData)
      } catch (error) {}
    }

    axios

      .get(
        apiAddress +
          `/api/RestaurantUserMapper/getbyuseridaAndRestaurantId?userId=${decodedData.UserId}&restaurantId=${Restauranttoken.id}`
      )
      .then((response) => {
        var list = [];
        response.data.map((dt, i) => {
          var obj = {
            id: dt.restaurantId,
            title: dt.restaurantName,
          };
          list.push(obj);
        });
        setRestaurantDatas(list);
      });
  };

  const restaurantAddedvalue = (props) => {
    console.log(props);
    setRestaurantAdded(props);
    // setRestaurantErr(false);
    loadMenuData(props);
    // loadKeyword(props);
    // console.log(restaurantAdded)

    // if (menuid !== undefined) {
    //   console.log(menuid)
    //   console.log(restaurantAdded)

    //   const newMenuIds = menuid.filter(menu => {
    //     return restaurantAdded.some(restaurant => restaurant.id === menu.restaurantId);
    //   });
    //   console.log(newMenuIds)
    //   //setMenuIds(newMenuIds);
    //   setMenuId(newMenuIds);
    // }
  };

  const [Menudata, setMenuData] = useState([]);
  const [allMenuData, setAllMenuData] = useState([]);
  const [menuid, setMenuId] = useState([]);

  const [Sectiondata, setSectiondata] = useState([]);
  const [allSectiondata, setallSectiondata] = useState([]);
  const [FoodItemdata, setFoodItemdata] = useState([]);
  const [allFoodItemdata, setallFoodItemdata] = useState([]);

  const loadMenuData = async (props) => {
    var list = [];
    var Alllist = [];
    props.map(async (d, i) => {
      const response = await axios.get(apiAddress + "/api/Menu/" + d.id);
      console.log(d.id);
      response.data.map((dt, i) => {
        var obj = {
          id: dt.menuId,
          title: dt.menuName,
          img: dt.logoUrl,
          restaurantName: dt.restaurantName,
          restaurantId: d.id,
        };
        list.push(obj);
        console.log(list);
        dt.MenuRestaurantMapperLists = [];
        Alllist.push(dt);
      });
      // Alllist = response.data;
    });
    setAllMenuData(Alllist);
    console.log(list);
    setMenuData(list);
  };

  const addValue = (props) => {
    var selectedList = [];
    props.map((obj) => {
      console.log(allMenuData);
      const object = Menudata.find((x) => x.id == obj.id);
      console.log(object);
      selectedList.push(object);
    });
    console.log(selectedList);
    setMenuId(selectedList);
    //setMainsectionErr(false);
    loadSectionData(props);
  };

  const loadSectionData = async (props) => {
    console.log(props);
    let sections = [];
    let Allsections = [];
    props.map(async (d, i) => {
      const response = await axios.get(
        apiAddress + "/api/Section/getallsectionbasedonmenuid?id=" + d.id
      );
      console.log(d.id);
      response.data.map((dt, i) => {
        let sectionNew = {
          id: dt.id,
          title: dt.keywordName,
          img: dt.iconUrl,
          menuId: d.id,
          restaurantId: d.restaurantId,
          restaurantName: d.title,
        };
        sections.push(sectionNew);
        console.log(sections);

        Allsections.push(dt);
      });
      // Alllist = response.data;
    });
    setallSectiondata(Allsections);
    console.log(sections);
    setSectiondata(sections);
  };
  const addValueSection = (props) => {
    console.log(props);
    setSelectedValue(props);
    loadFoodItemData(props);
    console.log(selectedValue);
  };

  const loadFoodItemData = async (props) => {
    console.log(props);
    let fooditems = [];
    let Allfooditems = [];
    props.map(async (d, i) => {
      const response = await axios.get(
        apiAddress + "/api/FoodItems/getallFooditemsBasecOnSectionId?id=" + d.id
      );
      console.log(response.data);
      response.data.map((dt, i) => {
        let fooditemObj = {
          id: dt.foodItemId,
          foodItemId: dt.foodItemId,
          title: dt.itemName,
        };
        fooditems.push(fooditemObj);
        Allfooditems.push(dt);
      });
      // Alllist = response.data;
    });
    setallFoodItemdata(Allfooditems);
    setFoodItemdata(fooditems);
  };

  const LinkFoodItems = () => {
    console.log(foodItemSelected);

    let fooditemList = [];

    foodItemSelected.map((dt, i) => {
      fooditemList.push(dt.id);
    });

    console.log(fooditemList);

    var url = apiAddress + "/api/FoodItems/LinkFoodItem";

    axios.put(url, fooditemList).then((response) => {
      toast.success("FoodItems successfully Linked", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });

      setRestaurantAdded([]);
      setMenuId([]);
      setSelectedValue([]);
      setfoodItemSelected([]);

      if(Openfrom == "Main"){
        props.linkmodalclose()
      }
      else if(Openfrom == "Edit"){
        props.linkmodalclose2()
      }
    });
    setopenArchiveConfirmaitonModal(false);
  };

  const [TimeValue, setTimeValue] = useState("");
  const [TimerSeletedValue, setTimerSeletedValue] = useState("");
  const timeValue = (props) => {
    console.log(props);
  };

  useEffect(() => {
    console.log(TimeValue);
    //setTimerSeletedValue(TimeValue.$H + ":" + TimeValue.$m)
    setTimerSeletedValue(TimeValue);
  }, [TimeValue]);

  useEffect(() => {
    console.log(TimerSeletedValue);
  }, [TimerSeletedValue]);

  return (
    <div>
      <React.Fragment>
        <Dialog
          maxWidth={"sm"}
          fullWidth={true}
          open={props.open}
          onClose={handleClose}
        >
          <SweetAlertModal
            headerText={"Do you want to leave without saving?"}
            bodyText={"All changes made will be lost"}
            open={openMenuCloseConfirmaitonModal}
            onyes={handleClose}
            close={() => {
              setopenMenuCloseConfirmaitonModal(false);
            }}
            id={2}
          />

          <SweetAlertModal
            headerText={"Are you sure?"}
            bodyText={"All changes made will be lost"}
            open={openArchiveConfirmaitonModal}
            onyes={LinkFoodItems}
            close={() => {
              setopenArchiveConfirmaitonModal(false);
            }}
          />
          <Grid container>
            <Grid item xs={6}>
              <DialogTitle>
                <div className="d-flex" style={{ gap: "8px" }}>
                  <div>
                    <img src={itemImg} style={{ width: "1.8rem" }} alt="" />
                  </div>

                  <span style={{ color: "#2a7fd4" }}>
                    GoTaste :- Link Food Items
                  </span>
                </div>
              </DialogTitle>
            </Grid>
            <Grid item xs={6}>
              <DialogActions>
                <Button onClick={() => setopenMenuCloseConfirmaitonModal(true)}>
                  <img src={Cancel} alt="Close" style={{ width: "1.2rem" }} />
                </Button>
              </DialogActions>
            </Grid>
          </Grid>
          <DialogContent style={{ backgroundColor: "#f3f0f3" }}>
            <div>
              <Grid container sx={{ padding: "0.5rem" }}>
                <Grid item xs={11} style={{ paddingTop: "1rem" }}>
                  <AutoCompleteMultiSelect
                    id={2}
                    placeholder={"Select a Restaurant"}
                    datas={restaurantDatas}
                    value={restaurantAddedvalue}
                    val={restaurantAdded}
                  />
                </Grid>
              </Grid>
            </div>
            <div>
              <Grid container sx={{ padding: "0.5rem" }}>
                <Grid item xs={11} style={{ paddingTop: "1rem" }}>
                  <AutoCompleteMultiSelect
                    id={88}
                    placeholder={"Select a Menu"}
                    datas={Menudata}
                    value={addValue}
                    val={menuid}
                  />
                </Grid>
              </Grid>
            </div>
            <div>
              <Grid container sx={{ padding: "0.5rem" }}>
                <Grid item xs={11} style={{ paddingTop: "1rem" }}>
                  <AutoCompleteMultiSelect
                    id={88}
                    placeholder={"Select a Section"}
                    datas={Sectiondata}
                    value={addValueSection}
                    val={selectedValue}
                  />
                </Grid>
              </Grid>
            </div>
            <div>
              <Grid container sx={{ padding: "0.5rem" }}>
                <Grid item xs={11} style={{ paddingTop: "1rem" }}>
                  <AutoCompleteMultiSelect
                    id={2}
                    placeholder={"Select a FoodItem"}
                    datas={FoodItemdata}
                    value={foodItemAddedvalue}
                    val={foodItemSelected}
                  />
                </Grid>
              </Grid>
            </div>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => setopenArchiveConfirmaitonModal(true)}
              color="primary"
            >
              Link Items
            </Button>
            <Button
              onClick={() => setopenMenuCloseConfirmaitonModal(true)}
              color="primary"
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    </div>
  );
}

export default FoodItemLinkDialog;
